import { combineReducers } from 'redux';

import { messagesListReducer } from './messagesList';
import { messageItemReducer } from './messageItem';

export const messagesReducer = combineReducers({
    messages: messagesListReducer,
    message: messageItemReducer,
});
